module.exports = __webpack_public_path__ + "img/logo.56336a3c.png";